<script setup>
import { defineAsyncComponent, reactive, onMounted, onUnmounted } from "vue";
import { EventHelper } from "@/helpers/eventHelper";
import { RouterView } from "vue-router";
import { SessionHelper } from "@/helpers/sessionHelper";
import { useJobStore } from "@/stores/jobStore";
import { useContactStore } from "@/stores/contactStore";
import { useProductStore } from "@/stores/productStore";

const createMenu = defineAsyncComponent(() => import("@/components/navigation/createMenu.vue"));
const mainMenu = defineAsyncComponent(() => import("@/components/navigation/mainMenu.vue"));

const state = reactive({
  amIAuthenticated: SessionHelper.amIAuthenticated
});

onMounted(async () => {
  if (SessionHelper.amIAuthenticated) {
    useContactStore();
    useProductStore();
    useJobStore();
  }

  EventHelper.on("userSessionChanged", amIAuthenticated => {
    state.amIAuthenticated = amIAuthenticated;

    if (amIAuthenticated) {
      useJobStore();
      useContactStore();
    }
  });
});

onUnmounted(() => {
  EventHelper.off("userSessionChanged");
});
</script>

<template>
  <header class="h-28 bg-white block top-0 right-0 w-full z-50" :style="{ height: state.amIAuthenticated ? 0 + 'px' : '' }">
    <transition name="fade">
      <div v-if="!state.amIAuthenticated" class="faktool-logo">
        <figure class="h-full my-0">
          <img src="@/assets/graphics/dafis-logo-color.svg" class="h-full" />
        </figure>
      </div>
    </transition>
  </header>

  <create-menu v-if="state.amIAuthenticated"></create-menu>

  <main class="my-8 md:mt-24 px-2 xl:px-8 bg-background" :class="{ 'ml-40 xl:ml-52': state.amIAuthenticated }">
    <RouterView />
  </main>

  <transition name="slide-left">
    <main-menu v-if="state.amIAuthenticated"></main-menu>
  </transition>
</template>

<style scoped>
.faktool-logo {
  transform: translateX(-50%);
  position: absolute;
  left: 50%;
  top: 20px;
  @apply h-20 z-50;
}
</style>
